/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Complete_SetupInputs */

const en_plan_complete_setup = /** @type {(inputs: Plan_Complete_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Setup`)
};

const es_plan_complete_setup = /** @type {(inputs: Plan_Complete_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar configuración`)
};

/**
* | output |
* | --- |
* | "Complete Setup" |
*
* @param {Plan_Complete_SetupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_complete_setup = /** @type {((inputs?: Plan_Complete_SetupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Complete_SetupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_complete_setup(inputs)
	return en_plan_complete_setup(inputs)
});